// extracted by mini-css-extract-plugin
module.exports = {"rate":"rateError_rate__28oeI"};